import { useState, useCallback, useEffect, useMemo } from 'react';
import useMemberRedeemApi from '@Apis/useMemberRedeemApi';
import { REWARD_ACTION_TYPE } from '@Constants/dataEnums';
import { parseDate } from '@Util/moment';

const PAGE_SIZE = 50;

const useRedeemHistory = () => {
    const [records, setRecords] = useState([]);
    const [pageInfo, setPageInfo] = useState({ pageIndex: 1, totalPage: 1 });
    const { getRedeemRecordsApi } = useMemberRedeemApi();

    const fetchHistory = useCallback(
        async (pageIndex = 1) => {
            const resp = await getRedeemRecordsApi({ pageIndex, pageSize: PAGE_SIZE, actionType: REWARD_ACTION_TYPE.REDEEM });

            if (resp) {
                const { list, ...paging } = resp;
                setPageInfo(paging);
                setRecords((prev) => (pageIndex === 1 ? list : [...prev, ...list]));
            }
        },
        // eslint-disable-next-line
        [],
    );

    useEffect(() => {
        fetchHistory(1);
    }, [fetchHistory]);

    // 依「YYYY-MM」把紀錄分組，並累計各月點數；Map 保留 API 回傳的時間順序
    const monthGroups = useMemo(() => {
        const map = new Map();
        records.forEach((record) => {
            const key = parseDate(record.recordDate, 'YYYY-MM'); // 交給 dayjs 解析年月，不依賴原始字串格式
            if (!map.has(key)) map.set(key, { key, records: [], monthlyPoints: 0 });
            const group = map.get(key);
            group.records.push(record);
            group.monthlyPoints += record.points;
        });
        return Array.from(map.values());
    }, [records]);

    const hasMore = pageInfo.pageIndex < pageInfo.totalPage;

    const loadMore = useCallback(() => {
        if (hasMore) fetchHistory(pageInfo.pageIndex + 1);
    }, [hasMore, pageInfo.pageIndex, fetchHistory]);

    return { monthGroups, hasMore, loadMore };
};

export default useRedeemHistory;
